import { api } from "@/lib/axios";

type UpdateData = {
  name: string;
  phone: string;
  email?: string;
  project: string;
  landSize: string;
  downPayment: string;
  monthlyPayment: string;
  appointmentDate?: string;
};

export default function updateOne(id: string, data: UpdateData) {
  return api.put(`deals/${id}`, {
    ...data,
    fullName: data.name,
    campaign: data.project,
    landMeasurement: data.landSize,
    mensuality: data.monthlyPayment,
    hitch: data.downPayment,
    source: "CRM",
  });
}
